interface Props {
  size?: number;
  pulse?: boolean;
  gleam?: boolean;
}

export default function HexLogo({ size = 32, pulse = false, gleam = true }: Props) {
  const cls = [pulse ? "hex-pulse" : "", !pulse && gleam ? "hex-gleam" : ""]
    .filter(Boolean)
    .join(" ");

  return (
    <svg width={size} height={size} viewBox="0 0 40 40" className={cls || undefined}>
      <defs>
        <linearGradient id="hexgrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#fbbf24" />
          <stop offset="50%" stopColor="#fb923c" />
          <stop offset="100%" stopColor="#ef4444" />
        </linearGradient>
      </defs>
      <polygon
        points="20,3 35,11 35,29 20,37 5,29 5,11"
        fill="none"
        stroke="url(#hexgrad)"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
      <polygon
        points="20,10 28,14 28,26 20,30 12,26 12,14"
        fill="url(#hexgrad)"
        opacity="0.25"
      />
    </svg>
  );
}
